<template>
    <div class="client-articles">
        <div class="client-articles__inner">
            <swiper
                :slidesPerView="slides"
                :space-between="30"
                :modules="modules"
                :slidesPerGroup="perGroup"
                :navigation="{
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next', 
                        }"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                class="main-slider"
                >
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>

                <swiper-slide 
                    v-for="(article, index) in articles"
                    :key="article.id"
                    class="main-slider__slide main-slide">
                    <div class="main-slide__article article">
                        <div
                            v-if="index % 2 == 0" 
                            class="swiper-button-prev"></div>
                        <div
                            v-else 
                            class="swiper-button-next"></div>
                        <h1 
                            :class="{textRight: index % 2 == 0, textLeft: index % 2 != 0}"
                            class="article__name">{{article.heading}}</h1>
                        <button 
                            type="button" 
                            @click="redirectToArticle(article.articleUrl)"
                            :class="{btnPositionRight: index % 2 == 0, btnPositionLeft: index % 2 != 0}"
                            class="article__btn">читать статью</button>
                        <img 
                            :class="{slideFirst: index % 2 == 0, slideSecond: index % 2 != 0}"
                            class="article__img"
                            :src="'https://lenbuket.ru:8443/' + article.previewImg">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { ref } from 'vue';

export default {
    data() {
        return {
            perGroup: 2,
            slides: 2,
            articles: []
        }
    },
    setup() {
        const onSwiper = (swiper) => {

        };
        const onSlideChange = () => {

        };
        const prev = ref(null);
        const next = ref(null);
        return {
            onSwiper,
            onSlideChange,
            modules: [Navigation, Pagination, Scrollbar, A11y],
            prev,
            next
        };
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    methods: {
        redirectToArticle(url){
            this.$router.push({name: 'currentNews', params: {'current': url}})
        },
        getArticles(){
            axios({
                method: 'GET',
                url: 'https://lenbuket.ru:8443/api/article/get'
            }).then((res)=>{
                this.articles = res.data
            })
        }
    },
    mounted() {
        if (window.innerWidth <= 600) {
            this.perGroup = 1
            this.slides = 1
        }
        this.getArticles()
    },
}
</script>

<style scoped>
    .main-slide__article{
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 15px;
        height: 100vh;
        max-height: 190px;
    }
    .article__name{
        position: relative;
        color: #fff;
        font-size: 24px;
        z-index: 999;
        font-weight: 400;
        text-transform: uppercase;
        font-family: 'Romul';
    }
    .article__btn{
        position: relative;
        color: #fff;
        font-size: 24px;
        z-index: 999;
        align-self: flex-end;
        margin-top: auto;
        font-family: "Bona Nova", serif;
    }
    .article__btn:hover{
        text-decoration: underline;
    }
    .article__img{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
    .slideFirst{
        border-radius: 70px 20px 20px 70px;
    }
    .slideSecond{
        border-radius: 20px 70px 70px 20px;
    }
    .textRight{
        text-align: right;
    }
    .textLeft{
        text-align: left;
    }
    .btnPositionLeft{
        align-self: flex-start;
    }
    .swiper-button-prev{
        color: #fff;
        left: 30px;
    }
    .swiper-button-next{
        color: #fff;
        right: 30px;
    }
    @media (max-width: 600px) {
        .article__img{
            border-radius: 15px;
            object-fit: cover;
        }
        .article__name{
            text-align: left;
            font-size: 20px;
        }
        .article__btn{
            align-self: flex-start;
        }
        .swiper-button-prev{
            left: 15px;
        }
        .swiper-button-next{
            right: 15px;
        }
    }
</style>